export default __webpack_public_path__ + "static/media/util-light.9acd3e95.svg";